import { useLocation } from 'react-router-dom';
import { GROUP_PAGES } from '../config/pages';
import { useGroupContext } from '../group-context';
import { useGroupFilters } from '../hooks/use-group-filters';
import { GroupOrgFilter } from './group-org-filter';
import { GroupPeriodFilter } from './group-period-filter';

function getFilterConfigForPath(pathname: string) {
  const page = Object.values(GROUP_PAGES).find(({ path }) => path === pathname);
  return page?.filters ?? { orgs: false, periods: false };
}

/**
 * Cluster of right-aligned global filters used in the group dashboard page
 * header's toolbar slot. Composes GroupOrgFilter and GroupPeriodFilter.
 *
 * Always renders a fixed-height container — even on filter-less routes
 * (Dashboard, Organisations) — so the page header's title row keeps a
 * consistent height across all `/group/*` pages and the title doesn't jump
 * vertically when navigating between filter and non-filter pages.
 */
export function GroupGlobalFilter() {
  const { pathname } = useLocation();
  const filterConfig = getFilterConfigForPath(pathname);
  const { organizations } = useGroupContext();
  const [{ orgs, periods }, setFilters] = useGroupFilters();

  return (
    <div className="flex min-h-10 flex-wrap items-center justify-end gap-2">
      {filterConfig.orgs && (
        <GroupOrgFilter
          organizations={organizations}
          selectedUuids={orgs}
          onChange={(next) => setFilters({ orgs: next })}
        />
      )}
      {filterConfig.periods && (
        <GroupPeriodFilter
          selectedPeriods={periods}
          onChange={(next) => setFilters({ periods: next })}
        />
      )}
    </div>
  );
}
